import { render, staticRenderFns } from "./AccountAssistants.vue?vue&type=template&id=7228586f&scoped=true"
import script from "./AccountAssistants.vue?vue&type=script&lang=js"
export * from "./AccountAssistants.vue?vue&type=script&lang=js"
import style0 from "./AccountAssistants.vue?vue&type=style&index=0&id=7228586f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228586f",
  null
  
)

export default component.exports